import { Component, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { URL_YT_NEXTCOMUNICA } from "../../../lib/constants";
import { DisplayService } from "../../../lib/services/display.service";
import { MatMenuItem, MatMenuTrigger, MatMenu } from "@angular/material/menu";
import { RouterLink } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: 'menu-portale-items',
    template: `
@if (isMatMenu) {
  <a mat-menu-item routerLink="/">Home</a>
  <a mat-menu-item routerLink="/vantaggi">Vantaggi</a>
  <a mat-menu-item routerLink="/scopri">Scopri di più</a>
  <a mat-menu-item [href]="URL_YT_NEXTCOMUNICA" target="_blank">YouTube</a>
  <a mat-menu-item routerLink="/diconoDiNoi">Dicono di noi</a>
  <!-- <a mat-menu-item routerLink="manuale">Manuale</a> -->
  <a mat-menu-item [routerLink]="['/', 'assistenza','contact','1']">Contattaci</a>
} @else {
  <a routerLink="/">Home</a>
  <a routerLink="/vantaggi">Vantaggi</a>
  <a routerLink="/scopri">Scopri di più</a>
  <a [href]="URL_YT_NEXTCOMUNICA" target="_blank">YouTube</a>
  <a routerLink="/diconoDiNoi">Dicono di noi</a>
  <!-- <a routerLink="manuale">Manuale</a> -->
  <a [routerLink]="['/', 'assistenza','contact','1']">Contattaci</a>
}
`,
    styles: [
        `
        a {
            border-radius: 8px;
            color: #35645e !important;
            font-weight: 600 !important;
            padding: 9px 16px;
            text-decoration: none;
        }`,
        `
        a span {
            color: #5eb8ac !important;
        }
        `,
        `
        a:hover {
            background-color: #e7f4f1;
            color: #216961 !important;
        }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatMenuItem, RouterLink]
})
export class MenuPortaleItemsComponent {
    @Input() isMatMenu: boolean = false

    URL_YT_NEXTCOMUNICA = URL_YT_NEXTCOMUNICA
}

@Component({
    selector: 'menu-portale',
    template: `
@if (!(displayService.isSmall | async)) {
  <div id="menu-big">
    <menu-portale-items></menu-portale-items>
  </div>
}
@if (displayService.isSmall | async) {
  <div id="menu-small">
    <a mat-menu-item [routerLink]="['/', 'assistenza','contact','1']">Contattaci</a>
    <mat-icon [matMenuTriggerFor]="beforeMenu">menu</mat-icon>
    <mat-menu #beforeMenu="matMenu" xPosition="before">
      <menu-portale-items [isMatMenu]="true"></menu-portale-items>
    </mat-menu>
  </div>
}
`,
    styles: [
        `
        #menu-big {
            backdrop-filter: blur(12px);
            background: rgba(255, 255, 255, .94);
            border-bottom: 1px solid #dceae7;
            box-shadow: 0 2px 12px rgba(22, 63, 60, .06);
            display: flex;
            flex-wrap: wrap;
            justify-content:center;
            padding: 9px 16px;
            position: sticky;
            top: 0;
            z-index: 100;
        }`,
        `
        #menu-small {
            background: #fff;
            border-bottom: 1px solid #dceae7;
            display: flex;
            justify-content: space-between;
            align-items: center;
            min-height: 54px;
            padding: 0 16px;
            position: sticky;
            top: 0;
            z-index: 100;
        }
        #menu-small mat-icon { color: #216961; }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MenuPortaleItemsComponent, MatMenuItem, RouterLink, MatIcon, MatMenuTrigger, MatMenu, AsyncPipe]
})
export class MenuPortaleComponent {    protected displayService = inject(DisplayService);


}
